function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useState } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Loader from "./../Loader/Loader";
import Select from "react-select";
import "./LiveStatsPage.css";
import Button from "react-bootstrap/Button";
import { LIVE_STATS_DETAILS_QUERY } from "./query";
import { useQuery, useLazyQuery } from "@apollo/client";
import { stringToArrayOutput } from "./../SideMenu/Header";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field, ErrorMessage } from "formik";
var LiveStatsPage = function LiveStatsPage(props) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    startTime = _React$useState2[0],
    setStartTime = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    endTime = _React$useState4[0],
    setEndTime = _React$useState4[1];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    authModalShow = _useState2[0],
    setAuthModalShow = _useState2[1];
  var _React$useContext = React.useContext(FilterContext),
    organisationSettings = _React$useContext.organisationSettings;
  var _React$useState5 = React.useState({
      label: "User Registration",
      value: "user-registration"
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    liveStatsParameterCheck = _React$useState6[0],
    setLiveStatsParameterCheck = _React$useState6[1];
  var _React$useState7 = React.useState(liveStatsParameterCheck.value == "plan-wise-data" ? {
      label: "All Time",
      value: "allTime"
    } : {
      label: "Today",
      value: "today"
    }),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    dateParameterCheck = _React$useState8[0],
    setDateParameterCheck = _React$useState8[1];
  React.useEffect(function () {
    if (liveStatsParameterCheck.value == "plan-wise-data") {
      setDateParameterCheck({
        label: "All Time",
        value: "allTime"
      });
    } else {
      setDateParameterCheck({
        label: "Today",
        value: "today"
      });
    }
  }, [liveStatsParameterCheck]);
  var liveStatsFilter = [{
    label: "User Registration",
    value: "user-registration"
  },
  // { label: "All Time Registration", value: "all-time-registration" },
  {
    label: "Plan Wise Data",
    value: "plan-wise-data"
  }, {
    label: "App Usage",
    value: "app-usage"
  }];
  React.useEffect(function () {
    var _stringToArrayOutput = stringToArrayOutput(dateParameterCheck.label, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone),
      _stringToArrayOutput2 = _slicedToArray(_stringToArrayOutput, 2),
      startDate = _stringToArrayOutput2[0],
      endDate = _stringToArrayOutput2[1];
    setStartTime(startDate);
    setEndTime(endDate ? endDate : startDate);
  }, [dateParameterCheck]);
  var _useLazyQuery = useLazyQuery(LIVE_STATS_DETAILS_QUERY, {
      variables: {
        //   startDate: startDate,
        //   endDate: endDate ? endDate : startDate,
        startDate: dateParameterCheck.value == "allTime" ? null : moment(startTime).format("YYYY-MM-DD"),
        endDate: dateParameterCheck.value == "allTime" ? null : moment(endTime).format("YYYY-MM-DD"),
        dateFilterType: dateParameterCheck.value,
        type: liveStatsParameterCheck.value
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    fetchUserStatus = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    liveStatsLoading = _useLazyQuery2$.loading,
    liveStatsData = _useLazyQuery2$.data,
    liveStatsError = _useLazyQuery2$.error;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "live-stats-page-root"
  }, /*#__PURE__*/React.createElement(LiveStatsPageFilter, {
    liveStatsParameterCheck: liveStatsParameterCheck,
    setLiveStatsParameterCheck: setLiveStatsParameterCheck,
    liveStatsFilter: liveStatsFilter
  }), /*#__PURE__*/React.createElement(LiveStatsPageData, {
    liveStatsParameterCheck: liveStatsParameterCheck,
    dateParameterCheck: dateParameterCheck,
    setDateParameterCheck: setDateParameterCheck,
    liveStatsLoading: liveStatsLoading,
    liveStatsData: liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.liveStatsDetails,
    liveStatsError: liveStatsError,
    startTime: startTime,
    endTime: endTime
  }), /*#__PURE__*/React.createElement(LiveStatsPageAuthorizationModal, {
    authModalShow: authModalShow,
    setAuthModalShow: setAuthModalShow,
    fetchUserStatus: fetchUserStatus
  })));
};
var LiveStatsPageFilter = function LiveStatsPageFilter(props) {
  var liveStatsParameterCheck = props.liveStatsParameterCheck,
    setLiveStatsParameterCheck = props.setLiveStatsParameterCheck,
    liveStatsFilter = props.liveStatsFilter;
  return /*#__PURE__*/React.createElement("div", {
    className: "live-stats-page-filter-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "live-stats-page-filter-dropdown"
  }, /*#__PURE__*/React.createElement(Select, {
    value: liveStatsParameterCheck,
    onChange: function onChange(e) {
      return setLiveStatsParameterCheck(e);
    },
    options: liveStatsFilter,
    className: "daily-attendance-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })));
};
var LiveStatsPageData = function LiveStatsPageData(props) {
  var liveStatsParameterCheck = props.liveStatsParameterCheck,
    dateParameterCheck = props.dateParameterCheck,
    setDateParameterCheck = props.setDateParameterCheck,
    liveStatsLoading = props.liveStatsLoading,
    liveStatsData = props.liveStatsData,
    liveStatsError = props.liveStatsError,
    startTime = props.startTime,
    endTime = props.endTime;
  var dateFilter = [{
    label: "Today",
    value: "today"
  }, {
    label: "Yesterday",
    value: "yesterday"
  }, {
    label: "This Week",
    value: "thisWeek"
  }, {
    label: "This Month",
    value: "thisMonth"
  }, {
    label: "All Time",
    value: "allTime"
  }];
  var dateFilterAppUsage = [{
    label: "Today",
    value: "today"
  }];
  var dateFilterPlanWiseData = [{
    label: "All Time",
    value: "allTime"
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "live-stats-page-content-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "live-stats-page-content-filter-label"
  }, liveStatsParameterCheck.label), /*#__PURE__*/React.createElement("div", {
    className: "live-stats-page-filter-date-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "live-stats-page-date-filter-dropdown"
  }, /*#__PURE__*/React.createElement(Select, {
    value: dateParameterCheck,
    onChange: function onChange(e) {
      return setDateParameterCheck(e);
    },
    options: liveStatsParameterCheck.value == "app-usage" ? dateFilterAppUsage : liveStatsParameterCheck.value == "plan-wise-data" ? dateFilterPlanWiseData : dateFilter,
    className: "daily-attendance-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  }))), liveStatsLoading ? /*#__PURE__*/React.createElement(Loader, null) : liveStatsError ? /*#__PURE__*/React.createElement("div", null, "Something went wrong, Pls refresh the page!") : liveStatsParameterCheck.value == "user-registration" ? /*#__PURE__*/React.createElement(React.Fragment, null, dateParameterCheck.value == "thisWeek" ? /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-date-text"
  }, "(", moment(startTime).startOf("day").format("DD MMM, YYYY"), " -", moment(endTime).endOf("day").format("DD MMM, YYYY"), ")") : null, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-root"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Registered Companies"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.registeredCompanies)), /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Registered Users"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.registeredUsers)), /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Latest app users"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.appUpdatedCount)))) : liveStatsParameterCheck.value == "plan-wise-data" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-root"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Total Free Plan"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.freeUserCount)), /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Total Trial Plan"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.trialProUserCount)), /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Total Pro Plan"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.proUserCount))), /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-root live-stats-page-dashboard-card-root-2"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Free Plan Active"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.freeUserCountActive)), /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Trial Plan Active"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.trialProUserCountActive)), /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Pro Plan Active"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.proUserCountActive)))) : /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-root"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Currently Working"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.workingUserCount)), /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "On Break"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.breakUserCount)), " ", /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "live-stats-page-dashboard-card-title text-dark"
  }, "Stopped Work"), /*#__PURE__*/React.createElement("h4", {
    "class": "mb-0 mt-1 font-weight-bold text-dark"
  }, liveStatsData === null || liveStatsData === void 0 ? void 0 : liveStatsData.stopUserCount))));
};
var LiveStatsPageAuthorizationModal = function LiveStatsPageAuthorizationModal(props) {
  var authModalShow = props.authModalShow,
    setAuthModalShow = props.setAuthModalShow,
    fetchUserStatus = props.fetchUserStatus;
  return /*#__PURE__*/React.createElement(Modal, {
    show: authModalShow,
    centered: true,
    size: "sm",
    className: "live-status-password-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: false
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "user-status-modal-title live-status-password-modal-title"
  }, "Authentication Required")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "live-status-password-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      password: ""
    },
    validate: function validate(values) {
      var errors = {};
      if (!values.password) {
        errors.password = "*Password required";
      } else if (values.password !== "1") {
        errors.password = "Invalid password";
      }
      return errors;
    },
    onSubmit: ( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(values.password === "1")) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return fetchUserStatus();
            case 3:
              _context.next = 5;
              return setAuthModalShow(false);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())
  }, function (_ref2) {
    var isSubmitting = _ref2.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Field, {
      type: "password",
      name: "password",
      className: "live-status-password-modal-body-password",
      placeholder: "Please enter password",
      autocomplete: "new-password",
      "aria-autocomplete": "off"
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "password",
      component: "div",
      className: "user-status-password-error"
    }), /*#__PURE__*/React.createElement("div", {
      className: "user-status-submit-div"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      size: "sm",
      type: "submit",
      className: "user-status-submit-button"
    }, "Submit")));
  })));
};
export default LiveStatsPage;